var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-container"},[_vm._t("default"),_c('div',{staticClass:"close-container"},[_vm._t("closeBtn",function(){return [_c('el-button',{staticClass:"close-btn",attrs:{"type":_vm.type},on:{"click":_vm.handleBack}},[_vm._v(_vm._s(_vm.text))])]})],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }